import LocalizedStrings from 'react-localization';

const translit = new LocalizedStrings({
    rus:
    {
        main: "Главная",
        top_players: "Топ игроков",
        lobby: "Лобби",
        time_to_play: "ВРЕМЯ ИГРАТЬ",
    },
    eng:
    {
        main: "Main",
        top_players: "Top players",
        lobby: "Lobby",
        time_to_play: "TIME TO PLAY",
    }

})

export default translit
